import useTranslate from 'hooks/useTranslate'

import { Container, WrapperCapped, WrapperCappedCentered, Error, Required, LAYOUT_CONFIGURATION } from './styled'

function LabelContent({ labelIntl, labelComponent, isRequired }) {
  const translate = useTranslate()

  if (labelComponent) {
    return labelComponent
  }

  const label = translate(labelIntl)

  return (
    <>
      {label}
      {isRequired && <Required>*</Required>}
    </>
  )
}

function Template({
  label: labelIntl,
  labelComponent,
  name,
  error,
  isRequired,
  disabled,
  children,
  className,
  Wrapper = WrapperCapped,
  layoutConfiguration = LAYOUT_CONFIGURATION.HORIZONTAL,
}) {
  const hasLabel = labelComponent ?? labelIntl

  return (
    <Container className={className}>
      <Wrapper layoutConfiguration={layoutConfiguration}>
        {hasLabel && (
          <Wrapper.Label htmlFor={!disabled ? name : undefined} layoutConfiguration={layoutConfiguration}>
            <LabelContent labelIntl={labelIntl} labelComponent={labelComponent} isRequired={isRequired} />
          </Wrapper.Label>
        )}
        <Wrapper.Content layoutConfiguration={layoutConfiguration}>{children}</Wrapper.Content>
      </Wrapper>
      {error && <Error data-testid="error">{error}</Error>}
    </Container>
  )
}

export default Template
export const LabelCapped = WrapperCapped
export const LabelCappedCenter = WrapperCappedCentered
export { LAYOUT_CONFIGURATION }
